var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "rental-card-wide col-lg-12 col-md-12" }, [
    _c(
      "div",
      {
        class: `boxed-widget--clean boxed-widget--mobile animate ${
          _vm.rental.hasWatermarkedImages && !this.$store.state.userIsPremium
            ? "rental-watermark-disable-hover"
            : ""
        }`,
      },
      [
        _vm.rental.status !== _vm.houseStatuses.rented_out
          ? _c(
              "div",
              [
                !_vm.rental.isBlurred
                  ? _c("adivare-favourite-btn-star", {
                      staticClass: "listing-like-top",
                      attrs: {
                        "rental-id": _vm.rental.id,
                        "rental-short-id": _vm.rental.shortId,
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("adivare-list-item-content", {
                  attrs: { rental: _vm.rental, index: _vm.index },
                }),
              ],
              1
            )
          : _c(
              "div",
              [
                _c(
                  "adivare-newsletter-subscribe-wrapper",
                  { attrs: { rentalShortId: _vm.rental.shortId } },
                  [
                    _c("i", { staticClass: "far fa-bell" }),
                    _vm._v(" "),
                    _c("adivare-list-item-content", {
                      attrs: { rental: _vm.rental, index: _vm.index },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }